import { getDomainBranding } from '../../tenant/tenantConfig.js';

const RUNES = ['ᚠ', 'ᚢ', 'ᚦ', 'ᚨ', 'ᚱ', 'ᚲ', 'ᚷ'];

export default function SplashScreen() {
  const branding = getDomainBranding();

  return (
    <>
      <style>{`
        @keyframes tryggrSplashFade {
          from { opacity: 0; transform: translateY(6px); }
          to   { opacity: 1; transform: none; }
        }
        @keyframes tryggrSplashFloat {
          0%, 100% { transform: translateY(0); }
          50%      { transform: translateY(-5px); }
        }
        @keyframes tryggrSplashRune {
          0%, 100% { opacity: 0.18; transform: scale(1); text-shadow: none; }
          50%      { opacity: 1;    transform: scale(1.18); text-shadow: 0 0 14px rgba(45,212,191,0.75); }
        }
        @keyframes tryggrSplashShip {
          0%   { left: -18%; }
          100% { left: 110%; }
        }
        @keyframes tryggrSplashWave {
          0%   { background-position: 0 0; }
          100% { background-position: 56px 0; }
        }
      `}</style>

      <div
        style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999,
          background: 'radial-gradient(ellipse at 50% 28%, #0d2530 0%, #050d0f 72%)',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 22,
          color: '#e8f4f3',
          fontFamily: "'Syne', system-ui, sans-serif",
          animation: 'tryggrSplashFade 360ms ease-out',
        }}
      >
        <div
          style={{
            width: 96,
            height: 96,
            borderRadius: 22,
            background: 'linear-gradient(135deg, #2dd4bf, #38bdf8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 0 60px rgba(45,212,191,0.35), 0 8px 28px rgba(0,0,0,0.55)',
            animation: 'tryggrSplashFloat 2.6s ease-in-out infinite',
          }}
        >
          {branding.logoSvgPath ? (
            <svg
              width={48}
              height={48}
              viewBox={branding.logoViewBox}
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d={branding.logoSvgPath} fill="#0d1f1e" />
            </svg>
          ) : (
            <span style={{ fontSize: 44, fontWeight: 800, color: '#0d1f1e' }}>
              {branding.initial}
            </span>
          )}
        </div>

        <div
          style={{
            fontFamily: "'Syne', system-ui, sans-serif",
            fontSize: 46,
            fontWeight: 800,
            letterSpacing: '-0.02em',
            lineHeight: 1,
          }}
        >
          {branding.name}
        </div>

        <div
          style={{
            fontFamily: "'Syne', system-ui, sans-serif",
            fontSize: 14,
            fontWeight: 500,
            color: '#8db8b4',
            letterSpacing: '0.04em',
            marginTop: -8,
          }}
        >
          Let&rsquo;s land your Thing.
        </div>

        <div style={{ display: 'flex', gap: 14, marginTop: 6 }}>
          {RUNES.map((r, i) => (
            <span
              key={i}
              style={{
                fontSize: 22,
                color: '#2dd4bf',
                opacity: 0.18,
                animation: `tryggrSplashRune 1.6s ease-in-out ${i * 0.16}s infinite`,
              }}
            >
              {r}
            </span>
          ))}
        </div>

        <div
          style={{
            position: 'relative',
            width: 320,
            height: 22,
            marginTop: 4,
            borderRadius: 4,
            background: 'linear-gradient(180deg, rgba(45,212,191,0.05), rgba(56,189,248,0.05))',
            backgroundImage: `repeating-linear-gradient(90deg,
            rgba(45,212,191,0.18) 0 2px,
            transparent 2px 14px),
            repeating-linear-gradient(180deg,
            rgba(45,212,191,0.10) 0 1px,
            transparent 1px 6px)`,
            backgroundSize: '56px 100%, 100% 6px',
            animation: 'tryggrSplashWave 2.4s linear infinite',
            overflow: 'hidden',
            borderTop: '1px solid rgba(45,212,191,0.18)',
            borderBottom: '1px solid rgba(45,212,191,0.18)',
          }}
        >
          <div
            style={{
              position: 'absolute',
              top: -8,
              height: 28,
              animation: 'tryggrSplashShip 3.2s ease-in-out infinite',
              color: '#e8f4f3',
              fontSize: 22,
              filter: 'drop-shadow(0 0 6px rgba(45,212,191,0.6))',
            }}
          >
            <svg width="40" height="28" viewBox="0 0 40 28" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 18 L38 18 L34 24 L6 24 Z" fill="#e8f4f3" />
              <path d="M20 4 L20 18" stroke="#e8f4f3" strokeWidth="1.5" />
              <path d="M20 5 L32 14 L20 14 Z" fill="#2dd4bf" />
              <path d="M8 14 L20 14 L20 6 Z" fill="#38bdf8" opacity="0.85" />
              <circle cx="6" cy="14" r="1.5" fill="#fbbf24" />
            </svg>
          </div>
        </div>
      </div>
    </>
  );
}
